/**
 * Validates if a string is a valid email address format
 * @param {string} email - The email address to validate
 * @returns {boolean} True if the email format is valid, false otherwise
 */
export function isValidEmail(email) {
  if (!email || typeof email !== "string") {
    return false;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Validates if a string is a valid URL format
 * @param {string} url - The URL to validate
 * @param {Object} options - Validation options
 * @param {boolean} [options.allowEmpty=true] - Whether to allow empty/falsy values
 * @returns {boolean} True if the URL format is valid, false otherwise
 */
export function isValidUrl(url, options = {}) {
  const { allowEmpty = true } = options;

  if (!url) {
    return allowEmpty;
  }

  if (typeof url !== "string") {
    return false;
  }

  try {
    new URL(url.startsWith("http") ? url : `https://${url}`);
    return true;
  } catch {
    return false;
  }
}
